import { contents } from '@shared/constants';

interface ContentProps {
  condition: keyof typeof contents;
  reviewTime: string;
}

export const ConditionalText: React.FC<ContentProps> = ({
  condition,
  reviewTime,
}) => {
  const component = contents[condition]?.map((text: string, index: number) => (
    <p key={index}>{text.replace('{reviewTime}', reviewTime)}</p>
  )) || <p>No condition satisfied</p>;

  return (
    <div className="text-bodyXl text-text-body mb-5 flex flex-col gap-6">
      {component}
    </div>
  );
};
